// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dated-row{border-radius:0;padding:7px 9px;margin-bottom:15px;width:655px;border-bottom:1px solid #727272}.dated-row-blue{border-radius:0;color:#000;padding-bottom:0}.dated-row-reverse-blue{background-color:#46aeff;color:#fafafa}.dated-row-title{font-style:italic;margin-top:9px;margin-bottom:10px;font-size:13px}", ""]);
// Exports
module.exports = exports;
